import get from 'lodash/get';

export const stateParamName = 'readyState';

const PROP_LOADING = 'loading';
const PROP_COMPLETE = 'complete';
const PROP_ERROR = 'error';

export const getReadyState = (state) => get(state, stateParamName, null);

export const getReadyStateModel = ({ loading = false, complete = false, error = false } = {}) => ({
  [PROP_LOADING]: loading,
  [PROP_COMPLETE]: complete,
  [PROP_ERROR]: error
});

export const isError = (state) => {
  const readyStateModel = getReadyState(state);
  return get(readyStateModel, PROP_ERROR, false);
};

export const isLoading = (state) => {
  const readyStateModel = getReadyState(state);
  return get(readyStateModel, PROP_LOADING, false);
};

export const isComplete = (state) => {
  const readyStateModel = getReadyState(state);
  return get(readyStateModel, PROP_COMPLETE, false);
};
